import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../add-staff/adduser.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import Loading from "../../components/loading/Loading";

function Usersedit() {
  const [loading, setLoading] = useState();
  const { id } = useParams();
  const [roles, setRoles] = useState([]);
  const [dataAwal, setDataAwal] = useState();
  const [modalShow, setModalShow] = useState(false);
  const navigate = useNavigate();
  const [title, setTitle] = useState();
  const sizeImage = 1000000;

  const getData = async () => {
    const result = await axios.get(`https://mobile.amospa.com/staff/${id}`);
    setDataAwal(result.data.data[0]);
    handlesetAdd(result.data.data[0]);
  };

  const [add, setAdd] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    roleId: "",
  });

  const handlesetAdd = (data) => {
    setAdd({
      name: data.name,
      phone: data.phone,
      email: data.email,
      password: data.password,
      roleId: data.Role.id,
    });
  };

  const [image, setImage] = useState("");

  const patchStaff = async () => {
    const data = new FormData();
    if (image.size > sizeImage) {
      setTitle("Image size is too Big, Maximum size 1MB");
      setModalShow(true);
    } else if (
      add.name !== dataAwal.name ||
      add.phone !== dataAwal.phone ||
      add.email !== dataAwal.email ||
      add.password !== dataAwal.password ||
      add.roleId !== dataAwal.Role.id ||
      image !== ""
    ) {
      data.append("name", add.name);
      data.append("phone", add.phone);
      data.append("email", add.email);
      data.append("password", add.password);
      data.append("roleId", add.roleId);
      data.append("image", image);
      setLoading(true);
      await axios.put(`https://mobile.amospa.com/staff/${id}`, data);
      setLoading(false);
      setTitle("Update Success");
      setModalShow(true);
    } else {
      setTitle("Tidak ada Perubahan");
      setModalShow(true);
    }
  };

  const getRoles = async () => {
    const rest = await axios.get("https://mobile.amospa.com/roles");
    setRoles(rest.data.data);
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/staff");
  };

  useEffect(() => {
    getData();
    getRoles();
  }, []);
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-user">
                <div className="wrapper-edit-image">
                  <div className="header-edit-image">
                    <h5 className="m-0">Update Staff</h5>
                  </div>
                  <div className="data-user">
                    <div className="wrapper-data">
                      <label>Name</label>
                      <input
                        type="text"
                        name="name"
                        onChange={(e) =>
                          setAdd({ ...add, name: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>Phone</label>
                      <input
                        type="text"
                        name="phone"
                        onChange={(e) =>
                          setAdd({ ...add, phone: e.target.value })
                        }
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>Email</label>
                      <input
                        type="text"
                        name="email"
                        onChange={(e) =>
                          setAdd({ ...add, email: e.target.value })
                        }
                      />
                    </div>

                    <div className="wrapper-data">
                      <label>Role</label>
                      <select
                        name="role"
                        onChange={(e) =>
                          setAdd({ ...add, roleId: e.target.value })
                        }
                      >
                        <option value={dataAwal && dataAwal.Role.id}>
                          Select Role
                        </option>
                        {roles.map((item, index) => (
                          <option key={index} value={item.id}>
                            {item.role}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="wrapper-data">
                      <label>
                        Image (Max 1MB)
                        <span className="text-danger ms-2">
                          {image && image.size > sizeImage
                            ? "Image size is too Big"
                            : ""}
                        </span>
                      </label>
                      <input
                        type="file"
                        onChange={(e) => setImage(e.target.files[0])}
                      />
                    </div>
                    <div className="wrapper-data">
                      <label>Password</label>
                      <input
                        type="password"
                        name="password"
                        onChange={(e) =>
                          setAdd({ ...add, password: e.target.value })
                        }
                      />
                    </div>
                    <button onClick={() => patchStaff()}>Update Staff</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Image size is too Big, Maximum size 1MB"
            ? handleNext
            : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Usersedit;
